import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { RootState } from 'reducers';
import { DatePicker } from 'components';
import { HomeService, PlanService } from 'services';
import { Globals } from 'utils';
import { Calendar } from 'assets/icons';
import NewPlanCard from './components/new-plan-card';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

interface State {
	currentPlan: any
	page: number
	last_page: number
	data: any[]
	form: {
		since: string
		until: string
	}
}

const INITIAL_STATE = {
	since: '',
	until: ''
}

class Plan extends React.Component<Props, State> {

	state: State = {
		currentPlan: null,
		page: 1,
		last_page: 1,
		data: [],
		form: INITIAL_STATE,
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Afiliaciones y pago',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const resPlan: any = await HomeService.affiliate.getPlan({ user_id: this.props.user?.id });

		this.setState({ currentPlan: resPlan.plan });
		this.getPayments();
	}

	getPayments = async (page: number = 1) => {
		try {
			const res: any = await PlanService.clinic.getHistory({
				page: this.state.page,
				...this.state.form,
				since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
				until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
				user_id: this.props.user?.id
			});
			this.setState({
				page,
				data: res.plan_payments.rows,
				last_page: res.plan_payments.count
			});

		} catch (error) {
			console.log(error)
		}
	}

	change = (value: any, target: keyof typeof INITIAL_STATE) => {
		this.setState(
			{ form: { ...this.state.form, [target]: value } },
			() => this.getPayments()
		);
	}

	onReset = () => {
		this.setState({ form: INITIAL_STATE }, () => this.getPayments());
	}

	render() {
		const { currentPlan, data } = this.state;
		const hasPendingPayment = data.some(
			(item: any) => item.status === 0 || String(item.status_text).toLowerCase() === 'pendiente'
		);
		return (
			<main className="affiliate-plan">
				<section className="affiliate-plan__content">
					<header className="header-section">
						<h2 className="title">Membresias</h2>
						{!currentPlan && (
							<div className="no-plan">
								<p>No posees un plan actualmente</p>
							</div>
						)}
						{currentPlan && (
							<div className="card-membership">
								<img className="poster" src={Globals.fromPhotos(currentPlan?.image)} alt="Plan Poster" />
								<div className="card-membership__info">
									<span className="tag">{currentPlan?.name}</span>
									<div className="expiry">
										<img src={Calendar} alt="Vencimiento" />
										<span>Vence: {moment(currentPlan?.next_payment, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
									</div>
								</div>
							</div>
						)}
					</header>

					<div className="history__filters">
						<DatePicker
							placeholder="Desde"
							showYearDropdown
							value={this.state.form.since}
							onChange={(v: string) => this.change(v, 'since')}
						/>
						<DatePicker
							placeholder="Hasta"
							showYearDropdown
							value={this.state.form.until}
							onChange={(v: string) => this.change(v, 'until')}
						/>

						{this.state.form !== INITIAL_STATE && (
							<button onClick={() => this.onReset()}>
								Limpiar
							</button>
						)}
					</div>

					<div className="history">
						<h3 className="history__title">Historial de pago</h3>

						<div className="history__table-container">
							<table>
								<thead>
									<tr>
										<th>Nombre</th>
										<th>Método de pago</th>
										<th>Tipo de pago</th>
										<th>N° Comprobante</th>
										<th>Cuota</th>
										<th>Fecha de pago</th>
										<th>Estatus</th>
									</tr>
								</thead>
								<tbody>
									{this.state.data.map((item: any, index: number) => (
										<tr key={index}>
											<td>{item?.plan_user?.plan?.name}</td>
											<td>{item?.payment_method?.name}</td>
											<td>{item.frequency_text}</td>
											<td>{item?.reference}</td>
											<td>{Globals.formatMiles(item.amount)}</td>
											<td>{String(item.date_es).replaceAll('/', '-')}</td>
											<td>{item?.status_text}</td>
										</tr>
									))}
								</tbody>
							</table>

							{!this.state.data.length && (
								<div className="no-plan">
									<p>Sin registros</p>
								</div>
							)}
						</div>
					</div>
				</section>

				<NewPlanCard history={this.props.history} hasPendingPayment={hasPendingPayment} />
			</main>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Plan);